import type { TutorialStep } from '@/services/tutorial.service';

const routeSteps: Record<string, TutorialStep[]> = {
    '/home': [
        {
            selector: '.welcome-section',
            title: 'Bem-vindo ao sistema COTIN',
            description:
                'Esta é a área de boas-vindas onde você encontra informações sobre o repositório COTIN.',
            position: 'bottom',
        },
        {
            selector: '.cards-grid .card:first-child',
            title: 'Cards de Navegação',
            description: 'Explore as diferentes seções do sistema através destes cards informativos.',
            position: 'right',
        },
        {
            selector: '.notification-btn',
            title: 'Notificações',
            description: 'Acompanhe suas notificações e alertas importantes aqui.',
            position: 'bottom',
        },
        {
            selector: '.user-info',
            title: 'Perfil do Usuário',
            description: 'Acesse seu perfil, configurações e opções de conta clicando aqui.',
            position: 'bottom',
        },
    ],
    '/comecando': [
        {
            selector: '.content-section:first-child',
            title: 'Página Começando',
            description:
                'Esta página contém informações sobre como começar a usar o sistema COTIN e seus componentes.',
            position: 'bottom',
        },
        {
            selector: '.content-section:nth-child(2)',
            title: 'Introdução ao sistema',
            description:
                'Aqui você encontra uma introdução completa sobre o sistema COTIN e suas funcionalidades principais.',
            position: 'bottom',
        },
        {
            selector: '.content-section:nth-child(3)',
            title: 'Por que usar nossa base de componentes?',
            description:
                'Descubra os benefícios e vantagens de utilizar nossa base de componentes no desenvolvimento de suas aplicações.',
            position: 'bottom',
        },
        {
            selector: '.content-section:nth-child(4)',
            title: 'Components',
            description:
                'Explore exemplos práticos de código e aprenda como utilizar os componentes do sistema COTIN em seus projetos.',
            position: 'right',
        },
    ],
    '/instalando': [
        {
            selector: '.content-section:first-child',
            title: 'Página Instalando',
            description:
                'Aqui você encontra instruções detalhadas sobre como instalar e configurar o sistema COTIN.',
            position: 'bottom',
        },
    ],
    '/api': [
        {
            selector: '.content-section:first-child',
            title: 'Página API',
            description:
                'Documentação completa da API do sistema COTIN, incluindo exemplos de uso e referências.',
            position: 'bottom',
        },
    ],
    '/figma': [
        {
            selector: '.content-section:first-child',
            title: 'Página Figma',
            description: 'Acesse os designs e protótipos do sistema COTIN disponíveis no Figma.',
            position: 'bottom',
        },
    ],
    '/ajuda': [
        {
            selector: '.content-section:first-child',
            title: 'Página de Ajuda',
            description: 'Encontre respostas para suas dúvidas e informações sobre como usar o sistema COTIN.',
            position: 'bottom',
        },
    ],
};

export function getTutorialStepsForRoute(pathname: string): TutorialStep[] {
    const normalized = pathname.split('?')[0].replace(/\/$/, '') || '/home';
    return routeSteps[normalized] ?? [];
}
